import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
// ANTES do render: quem lê `data-tema` durante o render (a Logo) precisa do
// atributo já no lugar. Num useEffect chegava tarde e a logo branca sumia
// sobre a navbar branca.
import { resolverTema } from './lib/temaPreview';
import { resolverUi } from './lib/uiCrm';

// O app INSTALADO abria em /escritorio/operacoes (start_url antigo do manifest),
// a tela "Operação · Hoje" que saiu do menu em 23/09: quem saía dela não achava
// o caminho de volta. O Chrome demora a atualizar o start_url de um app já
// instalado, então quem abre o app na tela antiga é levado pro Início. Só vale
// pra ABERTURA do app; a tela antiga continua alcançável pela URL e pela busca.
try {
  const instalado = window.matchMedia && window.matchMedia('(display-mode: standalone)').matches;
  if (instalado && window.location.pathname.replace(/\/+$/, '') === '/escritorio/operacoes') {
    window.history.replaceState(null, '', '/escritorio/inicio');
  }
} catch (_) { /* navegador sem matchMedia: segue como está */ }

resolverTema();
// Casca do cockpit (menu lateral + barra de topo). Nada guardado = o de hoje.
resolverUi();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
